@if (this.formControl.value) {
  <label [for]="id" [ngClass]="this.props.labelClass ?? 'font-bold'">
    <span [ngClass]="this.props.valueClass ?? 'text-lg'">{{ this.formControl.value }}</span>
    @if (this.props.required && !this.props.hideRequiredMarker) {
      <span aria-hidden="true" class="text-red-600">*</span>
    }
  </label>
}
